import CompleteSupportRequest from './ui/completeSupportRequest';

export default CompleteSupportRequest;
